// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"160":"b4a72691","746":"0b570d5f","798":"370125f1"}[chunkId] + ".chunk.js";
};